import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import oget from 'oget';
import moment from 'moment-timezone';

const defaultState = null;

export default (state = defaultState, { type, payload = {} }) => {
    switch (type) {
        case CONTESTS_SHOW_SUCCESS: {
            const {
                selectedHeatId,
                heatsById
            } = payload;

            const heatUpdated = oget(
                heatsById,
                `${selectedHeatId}.updated`
            );

            return heatUpdated
                ? moment(heatUpdated).toDate()
                : null;
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/api-time-updated.js